import React from 'react';

function StrokeSvg({ size, className, children }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      width={size}
      height={size}
      className={className}
      aria-hidden
      focusable={false}
    >
      <g stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round">
        {children}
      </g>
    </svg>
  );
}

/** Uczestnik — sylwetka + pinezka (aktywność na mapie) */
function IconRoleUser({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <circle cx="12" cy="8.5" r="3" />
      <path d="M6.5 19.5v-.3a5.5 5.5 0 0 1 11 0v.3" />
      <path d="M17.5 4.8c.9 0 1.6.7 1.6 1.6 0 1.3-1.6 3.2-1.6 3.2s-1.6-1.9-1.6-3.2c0-.9.7-1.6 1.6-1.6Z" />
    </StrokeSvg>
  );
}

/** Organizator — kalendarz z potwierdzeniem (host) */
function IconRoleOrganizer({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <rect x="5" y="6" width="14" height="12.5" rx="2" />
      <path d="M9 4.8v3.5M15 4.8v3.5M5 11h14" />
      <path d="M9.2 14.8 11.2 16.8 15.5 12.5" />
    </StrokeSvg>
  );
}

/** Moderator — tarcza z „M” */
function IconRoleModerator({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <path d="M12 3.2 19 6.8v6.4c0 3.4-2.8 6.2-7 8-4.2-1.8-7-4.6-7-8V6.8l7-3.6Z" />
      <path d="M9.2 15V9.5l2.8 2.2 2.8-2.2V15" />
    </StrokeSvg>
  );
}

/** Admin — korona techniczna (zęby + krzyżyk konfiguracji) */
function IconRoleAdmin({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <path d="M5.5 8.5h2.2l1.3-3 1.8 3h3.4l1.8-3 1.3 3h2.2v3H5.5v-3Z" />
      <path d="M8 11.5v5h8v-5" />
      <path d="M10.5 14h3M12 12.5v3" />
    </StrokeSvg>
  );
}

/** Pierwsze kroki — iskra + ślad */
function IconActivityStarter({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <path d="M12 4.5 13.8 9.2 18.5 11l-4.7 1.8L12 17.5l-1.8-4.7L5.5 11l4.7-1.8L12 4.5Z" />
      <path d="M6 18l2-2M4 14l1.5 1.5" />
    </StrokeSvg>
  );
}

/** Stały bywalec — wielokrotny znacznik w kalendarzu */
function IconActivityRegular({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <rect x="5" y="5.5" width="14" height="13.5" rx="2" />
      <path d="M9 3.8v3.2M15 3.8v3.2M5 10.5h14" />
      <path d="M8.5 13.5h2v2h-2zM11 13.5h2v2h-2zM13.5 13.5h2v2h-2z" />
    </StrokeSvg>
  );
}

/** Weteran — medal z wstążką */
function IconActivityVeteran({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <path d="M8 4.5h8v2.8a4 4 0 0 1-8 0V4.5Z" />
      <path d="M8 5.5H6.8a1.2 1.2 0 0 0 0 2.4H8M16 5.5h1.2a1.2 1.2 0 0 1 0 2.4H16" />
      <path d="M12 9.5v2.5" />
      <circle cx="12" cy="16" r="3.2" />
      <path d="M10.3 16l1.1 1.1 2.3-2.3" />
    </StrokeSvg>
  );
}

/** Towarzyski — dwie bańki + łączenie */
function IconActivitySocial({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <path d="M6.5 6.5h5a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-2l-2 1.8v-1.8H6.5A1.5 1.5 0 0 1 5 11v-3a1.5 1.5 0 0 1 1.5-1.5Z" />
      <path d="M12.5 9.5h5a1.5 1.5 0 0 1 1.5 1.5v2.5a1.5 1.5 0 0 1-1.5 1.5h-1.5l-1.8 1.6v-1.6h-.7a1.5 1.5 0 0 1-1.5-1.5V11.5" />
    </StrokeSvg>
  );
}

/** Motyl — uproszczone skrzydła wokół osi */
function IconActivityButterfly({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <path d="M12 5v14" />
      <path d="M12 9.5C9 7 6 8 6 11s3 3.5 6 1.5M12 9.5c3-2.5 6-1.5 6 1.5s-3 4-6 1.5" />
      <path d="M12 14.5c-1.8 1.5-1.8 1.5 0 3 1.8-1.5 1.8-1.5 0-3Z" />
    </StrokeSvg>
  );
}

/** Gospodarz — megafon + fala dźwięku */
function IconMegaphone({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <path d="M5 10.5v3a1.2 1.2 0 0 0 1.2 1.2h1.8l3.5 2.5V7.8L8 10.3H6.2A1.2 1.2 0 0 0 5 10.5Z" />
      <path d="M17.5 8.5a4 4 0 0 1 0 7" />
      <path d="M15.5 10v4" />
    </StrokeSvg>
  );
}

/** Pro host — podium + mikrofon */
function IconActivityHostPro({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <path d="M4 17h5v-4H4v4zM9.5 17h5v-6h-5v6zM15 17h5v-3h-5v3z" />
      <path d="M12 4.5v5.5M12 4.5h1.8a1 1 0 0 1 1 1v.8a1 1 0 0 1-1 1H12" />
    </StrokeSvg>
  );
}

/** Odkrywca — kompas */
function IconActivityExplorer({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <circle cx="12" cy="12" r="7.5" />
      <path d="M12 4.5v2M12 17.5v2M4.5 12h2M17.5 12h2" />
      <path d="m14.5 9.5-4 7-1.5-1.5 4-7 1.5 1.5Z" />
    </StrokeSvg>
  );
}

/** Beta — kolba Erlenmeyera, poziom cieczy, bąbelki */
function IconActivityBetaTester({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <path d="M9 4.2h6v1.2H9V4.2Z" />
      <rect x="10.1" y="5.35" width="3.8" height="3.15" rx="0.45" />
      <path d="M10.2 8.5 6.3 18.6h11.4L13.8 8.5" />
      <path d="M7.2 13.8h9.6" />
      <circle cx="9.3" cy="11.4" r="1" />
      <circle cx="14.8" cy="10.8" r="0.75" />
    </StrokeSvg>
  );
}

/** Wczesny — zegar + iskra (pierwsi w PlanGo) */
function IconActivityEarlyBeliever({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <circle cx="12" cy="13" r="5.5" />
      <path d="M12 9v4l2.5 1.5M12 7.5V6" />
      <path d="M18.5 4.5v2M17.5 5.5h2M19.5 7.5l-1.8 1M17.7 8.5l1.8 1" />
    </StrokeSvg>
  );
}

/** Wspierający — serce + pudełko podarunku */
function IconActivitySupporterDonor({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <path d="M12 17.5S7 14.2 5.8 11.5C5 9.8 6.2 8 8 8c1.2 0 2.2.6 2.8 1.5.6-.9 1.6-1.5 2.8-1.5 1.8 0 3 1.8 2.2 3.5C15.6 14.2 12 17.5 12 17.5Z" />
      <rect x="15.2" y="5.2" width="5.3" height="5.3" rx="0.9" />
      <path d="M15.2 8h5.3M17.85 5.2V4M16.5 4.5h2.6" />
    </StrokeSvg>
  );
}

/** Nieznana odznaka */
function IconFallback({ size = 16, className = 'badge-graphic-svg' }) {
  return (
    <StrokeSvg size={size} className={className}>
      <path d="M12 3.5 19 7v10l-7 3.5-7-3.5V7l7-3.5Z" />
      <path d="M12 16v.01M12 8.5v4" />
    </StrokeSvg>
  );
}

const BADGE_GRAPHICS = {
  role_user: IconRoleUser,
  role_organizer: IconRoleOrganizer,
  role_moderator: IconRoleModerator,
  role_admin: IconRoleAdmin,
  activity_starter: IconActivityStarter,
  activity_regular: IconActivityRegular,
  activity_veteran: IconActivityVeteran,
  activity_social: IconActivitySocial,
  activity_butterfly: IconActivityButterfly,
  activity_host: IconMegaphone,
  activity_host_pro: IconActivityHostPro,
  activity_explorer: IconActivityExplorer,
  activity_beta_tester: IconActivityBetaTester,
  activity_early_believer: IconActivityEarlyBeliever,
  activity_supporter_donor: IconActivitySupporterDonor,
};

/**
 * Ikona odznaki (obrys 24×24, currentColor) — zamiast emoji z definicji.
 */
export function BadgeGraphic({ badgeId, size = 16, className = 'badge-graphic-svg' }) {
  const Cmp = BADGE_GRAPHICS[badgeId] || IconFallback;
  return <Cmp size={size} className={className} />;
}
